<button mat-flat-button class="add-new"
*ngIf="isLicenseExceeded() && step.config.index === 0"
(click)="navToLicensePage()">ADD LICENSE
</button>